import styled from '@emotion/styled'
import { Dialog } from '@mui/material'

export const StarChartOrgAssignOrgDialogStyle = styled(Dialog)`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  backdrop-filter: blur(15px);
  display: flex;
  justify-content: center;
  align-items: center;
  .MuiPaper-root {
    max-width: 1000px !important;
        border-radius: 20px;
  }
`

export const StarChartOrgAssignOrgFormRow = styled.div`

  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  position: relative;
  @media (max-width: 1300px) {
    margin-top: 0;
    margin-left: 20px;
  }
`


export const StarChartOrgAssignOrgFormCol = styled.div<{
    alignment?: string
    Direction?: string
  }>`
    display: flex;
    justify-content: ${({ alignment }) => alignment};
    text-align: left;
    flex-direction: ${({ Direction }) => Direction};
    padding: 0 10px;
  `

  

export const StarChartOrgAssignOrgTitle = styled.h5`
  margin-bottom: 10px;
  font-size:24px;
`
export const StarChartOrgAssignOrgDesc = styled.p`

`

export const StarChartOrgAssignOrgCloseIcon = styled.img`
    position: absolute;
    right: 20px;
    cursor: pointer;
`
export const StarChartOrgAssignOrgList = styled.div`

  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  position: relative;
  max-height:200px;
  overflow-y:scroll;

`

